import React from 'react';
import '../../assets/css/homepage.css';
import {Line} from '@vds/lines';
import styled from 'styled-components';
import {checkUrlPath } from "../modules/CommonFunctions";
import CaretImage from "../../assets/resources/images/caret.png";
import {setNativeTitleWithNavigation, getValuesFromUserAgent, nativeBackAction,versionCompare,nativeHideTopBar} from "../../actions/native";
import ErrorBoundary from './ErrorHandler';
import { SiteCatalyst } from './SiteCatalyst';
import { RTCICall, MetricRTCICall } from "./RTCICall";
import {isNullOrUndefined , getOS } from "../modules/CommonFunctions";

const StyledLineNext = styled.div `height:3px`
const StyledLineLight = styled.div `height:2px`
const StyledPageTitle = styled.div`text-align:center;display:inline-block;  margin-left: 106px;font-family:Verizon NHG eTX`
const StylePageLine = styled.div`height:2px;`

class HomeOneAppSubsequent extends React.Component {

    constructor(props) {
        super(props);
        this.isValidUser = document.cookie.indexOf('userinfo') > -1 ? true : false;
    }

    componentDidMount(){
        const HomeTitle = localStorage.getItem('HomeTitle');
        let stitle = document.querySelector('title');
        stitle.setAttribute('aria-hidden' ,true);
        stitle.innerHTML = "";
        stitle.innerText ="";
        stitle.innerHTML = "Verizon "+ HomeTitle + "Support";
        stitle.innerText = "Verizon "+ HomeTitle + "Support";
            setNativeTitleWithNavigation(HomeTitle, true);
            nativeHideTopBar(true);
        let operatingSystem = getOS();
        let intent = "";
        let args = {
          homepage_name : "Residential Help",
          intentCategory: "ONEAPPHOME_DISPLAY",
          activityCategory: "ONEAPPHOME_DISPLAY",
          intent: intent,
          app_n_channel: "ONEAPPHOME-ESUPPORT",
          os: operatingSystem,
          pegaSessionID: "",
          userid: (this.isValidUser) ? window.userinfo.userId : "",
          visionID :  (this.isValidUser) ? window.userinfo.visionId : "",
          accountID:  (this.isValidUser) ? window.userinfo.visionAcctId : ""
          };
          RTCICall(args);
    }

    render() {
        const GuidedTitle = localStorage.getItem('GuidedTitle');
        const RelevantTitle = localStorage.getItem('RelevantTitle');
        var guidedstoredlist= JSON.parse(localStorage.getItem('GuidedItems'));
        var relevantstoredlist= JSON.parse(localStorage.getItem('RelevantItems'));

        const nodecoration={
            "outline":'none',
            "textDecoration": 'none'
        }

        let careticon;
        this.careticon =CaretImage;

        return(
            <div>
                <ErrorBoundary>
                <SiteCatalyst PageDetails={this.props.NeedMoreSupportData.pagedetails}/>
                </ErrorBoundary> 
                <div className="article-list">
                    <div className="HomeBody">                                                                                    
                            <div className="BoldSubtitle padding-top-medium">
                                <span>{GuidedTitle}</span>
                            </div>
                    </div>
                    <div className="Helorow" > 
                        <StyledLineNext>
                        <Line type="light"/>
                        </StyledLineNext>
                    </div>

                    {       
                    guidedstoredlist.map((item, index) => {
                    return (
                        <div key={index}>
                            <div className="HomeBody"> 
                            <a href={checkUrlPath(item.linkurl)} tabIndex="0" aria-label={item.linktext} style={nodecoration}>                                                                                     
                                <div className="BoldSubtitle">
                                    <a role = "link" href={checkUrlPath(item.linkurl) } 
                                    style={nodecoration} data-track={item.linktext}       
                                    tabIndex="-1" >
                                    { item.linktext } 
                                    </a>                                 
                                    <span className="CaretArrow"> 
                                        <img src={this.careticon} alt=" " ></img> 
                                    </span>
                                </div>  
                                </a>                             
                            </div>
                                {
                                !this.ValidRow && 
                                <div className="Helorow" > 
                                    <StyledLineLight>
                                    <Line type="xLight"/>
                                    </StyledLineLight>
                                </div>
                                }
                        </div> 
                        );
                    })
                    } 
                </div>

            {
            (relevantstoredlist != null && relevantstoredlist != undefined && relevantstoredlist != "" && relevantstoredlist.length>0) ? 
            <div className="article-list">
                <div className="HomeBody">                                                                                    
                    <div className="BoldSubtitle padding-top-medium">
                        <span>{RelevantTitle}</span>
                    </div>
                </div>
                <div className="Helorow" > 
                    <StyledLineNext>
                    <Line type="light"/>
                    </StyledLineNext>
                </div>
                {       
                relevantstoredlist.map((item, index) => {
                    return (
                        <div key={index}>
                            <div className="HomeBody">  
                               <a href={checkUrlPath(item.linkurl)} tabIndex="0" aria-label={item.linktext} style={nodecoration}>                                                                                  
                                <div className="BoldSubtitle">
                                    <a href={checkUrlPath(item.linkurl) } 
                                    style={nodecoration} data-track={item.linktext} 
                                    tabIndex="-1" >
                                    { item.linktext }      
                                    </a>                                
                                    <span className="CaretArrow"> 
                                        <img src={this.careticon} alt=" " ></img> 
                                    </span>
                                </div> 
                                </a>                              
                            </div>
                            {
                            !this.ValidRow && 
                            <div className="Helorow" > 
                                <StyledLineLight>
                                <Line type="xLight"/>
                                </StyledLineLight>
                            </div>
                            }
                        </div> 
                        );
                    })
                } 
            </div>              
        :
        ""
    }
    </div>
    );       
    }
}

export default HomeOneAppSubsequent


// WEBPACK FOOTER //
// ./src/components/modules/HomeOneAppSubsequent.js